module.exports = __webpack_public_path__ + "static/blb-partner-befa2dbd0e6712c591651ba5ec281783.png";